import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { APP_NAME, LOGO } from "@/lib/brand";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { t } from "@/lib/i18n";

export default function Verify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token");
    if (!token) {
      setState("error");
      setMsg("Token mancante.");
      return;
    }
    (async () => {
      try {
        await api.get("/auth/verify", { params: { token } });
        setState("ok");
      } catch (e) {
        setState("error");
        setMsg(apiError(e.response?.data?.detail));
      }
    })();
  }, [params]);

  return (
    <div className="min-h-screen app-soft-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-border rounded-2xl p-8 text-center shadow-sm">
        <img src={LOGO} alt={APP_NAME} className="h-12 w-12 rounded-xl mx-auto mb-5" />
        {state === "loading" && <Loader2 className="h-10 w-10 animate-spin text-primary mx-auto" />}
        {state === "ok" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto mb-3" />
            <h1 className="font-display text-2xl font-extrabold">{t("Email confermata!")}</h1>
            <p className="text-muted-foreground text-sm mt-2">{t("Il tuo account è attivo. Ora puoi accedere.")}</p>
            <Button className="w-full h-11 mt-6 font-semibold" onClick={() => navigate("/login")} data-testid="verify-login-btn">
              {t("Vai al login")}
            </Button>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="h-12 w-12 text-destructive mx-auto mb-3" />
            <h1 className="font-display text-2xl font-extrabold">{t("Verifica non riuscita")}</h1>
            <p className="text-muted-foreground text-sm mt-2">{msg || t("Link non valido o già usato.")}</p>
            <Button variant="outline" className="w-full h-11 mt-6" onClick={() => navigate("/login")}>
              {t("Torna al login")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
